import React from 'react';
import styled, { css } from 'styled-components';
import { Check, Remove } from '@mui/icons-material';
import { mpEvent, MPEvents } from 'src/utils/mixpanel';

const Div = styled.div<{ $isChecked: boolean; $indeterminate?: boolean; $disabled?: boolean }>`
  height: 24px;
  width: 24px;
  border: 2px solid ${({ theme }) => theme.colors.gp1};
  /* background: ${({ theme }) => theme.colors.white}; */
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  cursor: pointer;

  svg {
    color: ${({ theme }) => theme.colors.btnWhite};
    font-size: 16px;
  }

  ${({ $isChecked, $indeterminate }) =>
    ($isChecked || $indeterminate) &&
    css`
      border: none;
      background: ${({ theme }) => theme.colors.gradient};
    `};

  ${({ $disabled, $isChecked, $indeterminate, theme }) =>
    $disabled &&
    css`
      background: ${theme.colors.cflowerBlue};
      cursor: default;
      border: 2px solid ${theme.colors.cflowerBlue};
      background: ${$isChecked || $indeterminate ? theme.colors.cflowerBlue : 'transparent'};
    `};

  ${({ theme }) => theme.breakpoints.down('sm')} {
    height: 20px;
    width: 20px;
  }
`;

interface GTCheckBoxProps {
  onClick: () => void;
  isChecked: boolean;
  indeterminate?: boolean;
  disabled?: boolean;
  style?: React.CSSProperties;
  dataCy?: string;
}

export const GTCheckBox: React.FC<GTCheckBoxProps> = ({
  onClick,
  isChecked,
  indeterminate = false,
  disabled,
  style,
  dataCy = 'select-control',
}) => {
  return (
    <Div
      $isChecked={isChecked}
      $indeterminate={indeterminate}
      $disabled={disabled}
      style={style}
      onClick={(e) => {
        e.stopPropagation();
        if (!disabled) {
          onClick();
          mpEvent(MPEvents.TableCheckboxClick, {
            value: isChecked ? 'unchecked' : 'checked',
          });
        }
      }}
      data-cy={dataCy}
      className="gt-checkbox"
    >
      {isChecked && <Check />}
      {indeterminate && !isChecked && <Remove />}
    </Div>
  );
};
